import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, CfetService } from '../../cfet-core';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent extends CfetBaseComponent implements OnInit {

  constructor(private cfetService: CfetService) { super(); }

  ngOnInit () {
    window.scrollTo(0, 0);
    this.cfetService.isLandingPage.next(true);
  }

}
